export default {
  atDepth: '{valueUnit} na {depth} {depthUnit}',
  time: 'Čas',
  temp: 'Teplota',
  nlPerHPerM: 'Tok',
  cAtm: 'Atmosféra',
  cnAtm: 'Atmosféra',
  cd: 'Hĺbka cementácie',
  retainedAustenite: 'zost. aust. ca.',
  hardnessProfile: 'Tvrdosť',
  modal: {
    header: 'Konfigurácia tabuľky uhlíka',
    depth: 'Hĺbka',
  },
};
